import React, { useMemo } from "react";
import "./App.css";
import jmcLogo from "./assets/jmc-logo.png";
import { Routes, Route, useNavigate } from "react-router-dom";

import MerchantLogin from "./merchant/MerchantLogin";
import MerchantRouteGuard from "./merchant/components/MerchantRouteGuard";
import MerchantDashboard from "./merchant/pages/MerchantDashboard";
import MerchantForms from "./merchant/pages/MerchantForms";
import Form1CompanyOverview from "./merchant/pages/forms/Form1CompanyOverview";
import Form2Representative from "./merchant/pages/forms/Form2Representative";
import Form3PaymentHandling from "./merchant/pages/forms/Form3PaymentHandling";
import Form4Products from "./merchant/pages/forms/Form4Products";
import Form5SalesMethod from "./merchant/pages/forms/Form5SalesMethod";
import Form6StoreList from "./merchant/pages/forms/Form6StoreList";
import Form7ContactPerson from "./merchant/pages/forms/Form7ContactPerson";

import StaffLanding from "./staff/pages/StaffLanding";
import StaffDashboard from "./staff/pages/StaffDashboard";
import StaffRouteGuard from "./staff/components/StaffRouteGuard";
import CreateMerchant from "./staff/pages/CreateMerchant";
import MerchantList from "./staff/pages/MerchantList";
import MerchantDetail from "./staff/pages/MerchantDetail";
import StaffProgressList from "./staff/pages/StaffProgressList";
import StaffProgressDetail from "./staff/pages/StaffProgressDetail";
import StaffFormRouter from "./staff/pages/StaffFormRouter";

import MerchantUploads from "./merchant/pages/MerchantUploads";

import StaffDocumentDetail from "./staff/pages/StaffDocumentDetail";

import MerchantSubmitReview from "./merchant/pages/MerchantSubmitReview";

import StaffRingiCreate from "./staff/pages/StaffRingiCreate";

import StaffApprovedList from "./staff/pages/StaffApprovedList";


import StaffApprovedDetail from "./staff/pages/StaffApprovedDetail";


import MerchantAllInOne from "./merchant/pages/MerchantAllInOne";








type NavItem = { label: string; targetId: string };

function Home() {
  const navigate = useNavigate();

  const navItems: NavItem[] = useMemo(
    () => [
      { label: "機能", targetId: "features" },
      { label: "会社情報", targetId: "about" },
      { label: "お問い合わせ", targetId: "contact" },
    ],
    []
  );

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="lp-page">
      {/* Top bar */}
      <header className="lp-topbar">
        <div className="lp-left">
          <img src={jmcLogo} alt="JMC" className="lp-logo" />
          <div className="lp-brand">
            <div className="lp-brand-name">JMC</div>
            <div className="lp-brand-sub">加盟店登録ポータル</div>
          </div>
        </div>

        <nav className="lp-nav">
          {navItems.map((item) => (
            <button
              key={item.targetId}
              className="lp-nav-link"
              onClick={() => scrollTo(item.targetId)}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="lp-right">
          <a
            className="lp-company-link"
            href="https://www.jmc-ltd.co.jp/"
            target="_blank"
            rel="noreferrer"
          >
            会社サイト
          </a>

          <button className="lp-login-btn" onClick={() => navigate("/merchant-login")}>
            加盟店ログイン
          </button>
        </div>
      </header>

      {/* HERO */}
      <section className="lp-hero" id="top">
        <div className="lp-hero-inner">
          <div className="lp-hero-left">
            <div className="lp-pill">加盟店登録ポータル</div>

            <h1 className="lp-hero-title">
              加盟店登録を
              <br />
              かんたん・確実に
            </h1>

            <p className="lp-hero-desc">
              加盟店登録に必要な情報入力と書類（PDF）のアップロードを行うポータルです。
              進捗を保存し、完了後に提出できます。
            </p>

            <div className="lp-vm">
              <div className="lp-vm-card">
                <div className="lp-vm-label">ビジョン</div>
                <div className="lp-vm-text">人に、社会に、もっとやさしいシステムを。</div>
              </div>
              <div className="lp-vm-card">
                <div className="lp-vm-label">ミッション</div>
                <div className="lp-vm-text">
                  加盟店登録に必要な入力と書類提出を、安全かつ分かりやすく実現する。
                </div>
              </div>
            </div>

            <div className="lp-principles">
              <div className="lp-principle">01 セキュリティ最優先</div>
              <div className="lp-principle">02 シンプルで分かりやすく</div>
              <div className="lp-principle">03 進捗が見える化</div>
            </div>

            <div className="lp-hero-actions">
              <button className="lp-primary" onClick={() => navigate("/merchant-login")}>
                加盟店ログイン
              </button>

              <button className="lp-secondary" onClick={() => scrollTo("features")}>
                機能を見る
              </button>
            </div>
          </div>

          <div className="lp-hero-right">
            <div className="lp-glass">
              <div className="lp-glass-title">ポータル概要</div>

              <div className="lp-glass-row">
                <div className="lp-glass-label">できること</div>
                <div className="lp-glass-value">
                  必要な情報入力、書類アップロード、進捗保存、完了後の提出。
                </div>
              </div>

              <div className="lp-glass-row">
                <div className="lp-glass-label">管理</div>
                <div className="lp-glass-value">
                  入力・アップロードの進捗を見える化し、未完了を防ぎます。
                </div>
              </div>

              <div className="lp-glass-row">
                <div className="lp-glass-label">サポート</div>
                <div className="lp-glass-value">
                  お困りの場合は担当のJMCスタッフへご連絡ください。
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="lp-section" id="features">
        <div className="lp-section-inner">
          <h2 className="lp-section-title">機能</h2>
          <p className="lp-section-sub">
            加盟店登録の入力〜書類提出までを、迷わず進められるように設計しています。
          </p>

          <div className="lp-cards">
            <div className="lp-card">
              <div className="lp-card-title">必要情報の入力</div>
              <div className="lp-card-text">
                フォームに沿って必要項目を入力できます。途中保存にも対応します。
              </div>
            </div>

            <div className="lp-card">
              <div className="lp-card-title">PDF/書類アップロード</div>
              <div className="lp-card-text">
                指定された書類（複数PDF）をアップロードして提出できます。
              </div>
            </div>

            <div className="lp-card">
              <div className="lp-card-title">進捗管理</div>
              <div className="lp-card-text">
                どこまで完了したかを可視化し、提出漏れを防ぎます。
              </div>
            </div>

            <div className="lp-card">
              <div className="lp-card-title">提出・差戻し対応</div>
              <div className="lp-card-text">
                完了後に提出。必要に応じて修正依頼にも対応できる設計です。
              </div>
            </div>

            <div className="lp-card">
              <div className="lp-card-title">安全なアクセス</div>
              <div className="lp-card-text">
                加盟店ごとにID/PWを発行し、専用ページで作業できます。
              </div>
            </div>

            <div className="lp-card">
              <div className="lp-card-title">サポート導線</div>
              <div className="lp-card-text">
                困った時は担当者にすぐ連絡できる導線を用意します。
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section className="lp-section lp-section-alt" id="about">
        <div className="lp-section-inner">
          <h2 className="lp-section-title">会社情報</h2>
          <p className="lp-section-sub">
            詳細は会社サイトをご覧ください。ポータルでは加盟店登録に必要な情報を中心にご案内します。
          </p>

          <div className="lp-about-grid">
            <div className="lp-about-card">
              <div className="lp-about-title">私たちの指針</div>
              <ul className="lp-list">
                <li>セキュリティ最優先</li>
                <li>シンプルで分かりやすく</li>
                <li>進捗が見える化</li>
              </ul>
            </div>

            <div className="lp-about-card">
              <div className="lp-about-title">会社サイト</div>
              <p className="lp-about-text">
                会社情報・事業内容・採用情報などは、こちらをご確認ください。
              </p>
              <a
                className="lp-about-link"
                href="https://www.jmc-ltd.co.jp/"
                target="_blank"
                rel="noreferrer"
              >
                https://www.jmc-ltd.co.jp/
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section className="lp-section" id="contact">
        <div className="lp-section-inner">
          <h2 className="lp-section-title">お問い合わせ</h2>
          <p className="lp-section-sub">
            ポータルの操作に関するお問い合わせは、担当のJMCスタッフまでご連絡ください。
          </p>

          <div className="lp-contact">
            <div className="lp-contact-card">
              <div className="lp-contact-title">ご連絡先</div>
              <div className="lp-contact-text">
                ・担当のJMCスタッフへご連絡ください。
                <br />
                ・会社サイトのお問い合わせフォームもご利用いただけます。
              </div>

              <a
                className="lp-contact-link"
                href="https://www.jmc-ltd.co.jp/"
                target="_blank"
                rel="noreferrer"
              >
                会社サイトへ
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="lp-footer">
        <div className="lp-footer-inner">
          <div className="lp-footer-brand">
            <img src={jmcLogo} alt="JMC" className="lp-footer-logo" />
            <div>
              <div className="lp-footer-name">JMC</div>
              <div className="lp-footer-sub">加盟店登録ポータル</div>
            </div>
          </div>

          <div className="lp-footer-links">
            <button className="lp-footer-link" onClick={() => scrollTo("features")}>
              機能
            </button>
            <button className="lp-footer-link" onClick={() => scrollTo("about")}>
              会社情報
            </button>
            <button className="lp-footer-link" onClick={() => scrollTo("contact")}>
              お問い合わせ
            </button>
          </div>
        </div>

        <div className="lp-footer-bottom">
          <small>© JMC</small>
        </div>
      </footer>
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/merchant-login" element={<MerchantLogin />} />

      {/* Merchant */}
      <Route
        path="/merchant/dashboard"
        element={
          <MerchantRouteGuard>
            <MerchantDashboard />
          </MerchantRouteGuard>
        }
      />
      <Route path="/merchant/forms" element={<MerchantForms />} />
      <Route path="/merchant/forms/company-overview" element={<Form1CompanyOverview />} />
      <Route path="/merchant/forms/representative" element={<Form2Representative />} />
      <Route path="/merchant/forms/payment-handling" element={<Form3PaymentHandling />} />
      <Route path="/merchant/forms/products" element={<Form4Products />} />
      <Route path="/merchant/forms/sales-method" element={<Form5SalesMethod />} />
      <Route path="/merchant/forms/store-list" element={<Form6StoreList />} />
      <Route path="/merchant/forms/contact-person" element={<Form7ContactPerson />} />

      {/* Staff */}
      <Route path="/staff" element={<StaffLanding />} />
      <Route
        path="/staff/dashboard"
        element={
          <StaffRouteGuard>
            <StaffDashboard />
          </StaffRouteGuard>
        }
      />
      <Route path="/staff/create-merchant" element={<CreateMerchant />} />
      <Route path="/staff/merchants" element={<MerchantList />} />
      <Route path="/staff/merchants/:merchantId" element={<MerchantDetail />} />
      <Route path="/staff/progress" element={<StaffProgressList />} />
      <Route path="/staff/progress/:merchantId" element={<StaffProgressDetail />} />
      <Route
  path="/merchant/uploads"
  element={
    <MerchantRouteGuard>
      <MerchantUploads />
    </MerchantRouteGuard>
  }
/>


<Route
  path="/staff/progress/:merchantId/documents/:documentKey"
  element={
    <StaffRouteGuard>
      <StaffDocumentDetail />
    </StaffRouteGuard>
  }
/>

<Route
  path="/merchant/submit-review"
  element={
    <MerchantRouteGuard>
      <MerchantSubmitReview />
    </MerchantRouteGuard>
  }
/>


<Route
  path="/staff/progress/:merchantId/ringi"
  element={
    <StaffRouteGuard>
      <StaffRingiCreate />
    </StaffRouteGuard>
  }
/>

<Route
  path="/staff/approved"
  element={
    <StaffRouteGuard>
      <StaffApprovedList />
    </StaffRouteGuard>
  }
/>

<Route
  path="/staff/approved/:merchantId"
  element={
    <StaffRouteGuard>
      <StaffApprovedDetail />
    </StaffRouteGuard>
  }
/>



<Route
  path="/merchant/register"
  element={
    <MerchantRouteGuard>
      <MerchantAllInOne />
    </MerchantRouteGuard>
  }
/>






      {/* Single staff form router */}
      <Route
        path="/staff/progress/:merchantId/forms/:formKey"
        element={
          <StaffRouteGuard>
            <StaffFormRouter />
          </StaffRouteGuard>
        }
      />
    </Routes>






  );
}
